import React from "react";
import EditIcon from "../../../../assets/svgs/Edit.jsx";

const AccountDetails = () => {
  return (
    <div className="rounded-lg shadow-xl flex flex-col py-5 mb-10 text-sm sm:text-base">
      <div className="flex justify-between py-5 px-5 md:px-9 border-b text-base sm:text-lg">
        <p className="text-lg font-semibold">Account Deatils</p>
        <button className="flex space-x-1">
          <EditIcon />
          <span>Edit Info</span>
        </button>
      </div>

      <div className="space-y-4 px-9 py-2">
        <div className="w-full sm:w-2/4 inline-flex flex-col">
          <h3 className="font-medium">Bank Name</h3>
          <p className="text-xs">Citibank</p>
        </div>
        <div className="w-full sm:w-2/4 inline-flex flex-col">
          <h3 className="font-medium">Bank Branch</h3>
          <p className="text-xs">New Delhi</p>
        </div>
        <div className="w-full sm:w-2/4 inline-flex flex-col">
          <h3 className="font-medium">Account Name</h3>
          <p className="text-xs">OURS Technology</p>
        </div>
        <div className="w-full sm:w-2/4 inline-flex flex-col">
          <h3 className="font-medium">Account Number</h3>
          <p className="text-xs">5205896212</p>
        </div>
        <div className="w-full sm:w-2/4 inline-flex flex-col">
          <h3 className="font-medium">Tax Number</h3>
          <p className="text-xs">1120-S</p>
        </div>
        <div className="w-full sm:w-2/4 inline-flex flex-col">
          <h3 className="font-medium">Security NUmber</h3>
          <p className="text-xs">465-42-1568</p>
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;
